import { render, staticRenderFns } from "./ContactFormAlert.vue?vue&type=template&id=4b7e47b3&"
import script from "./ContactFormAlert.vue?vue&type=script&lang=js&"
export * from "./ContactFormAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports